import React from "react";
import Modal from "react-bootstrap/Modal";
import "./exportCompanyAttendanceReport.css";
import strings from "../../../utils/property-file/companyExport.json";
import closeIcon from "../../../Asset/Images/close-for-logout.svg";
import { useNavigate } from "react-router-dom"
import constants from "../../../utils/constants";
import { CompanyLevelAttendanceContext } from "../../companyLevelAttendanceContext";
import { useContext, useEffect, useState } from "react";
import * as FileSaver from "file-saver";
import * as XLSX from "xlsx"; 
import moment from "moment";
import { toast } from "react-toastify";
import pdfIcon from "../../../Asset/Images/pdf-icon.png"
import excelIcon from "../../../Asset/Images/excel-icon.png"
import SpinnerButtonMedium from "../../button/SpinnerButtonMedium";
import PropTypes from "prop-types"

export default function ExportCompanyAttendanceReport(props) {
  const nav = useNavigate();
  const {attendanceData } = useContext(CompanyLevelAttendanceContext);
  const companyName= localStorage.getItem(strings.localStorageCompanyName);
  const [fileTypeExport , setFileTypeExport] = useState("");

  // Extract time into Hours and minutes
  const parseTime = (timeString) => {
    const [hours, minutes] = timeString.split(':').map(Number);
    return hours * 60 + minutes;
  };

  // Calculation of time difference
  function TimeDifferenceCalculator( time1, time2 ) {
    const minutes1 = parseTime(time1);
    const minutes2 = parseTime(time2);
    const timeDifferenceInMinutes = minutes2 - minutes1;
    const hours = Math.floor(timeDifferenceInMinutes / 60);
    const remainingMinutes = timeDifferenceInMinutes % 60;
    return `${hours}h ${remainingMinutes}min`;
  }

  const [pdfActive,setPDFActive] = useState("pdf-type");
  const [excelActive,setExcelActive] = useState("excel-type");

  useEffect(()=>{
    if(fileTypeExport===strings.pdfLabel){
      setPDFActive("active-export-type");
      setExcelActive("excel-type");
    }
    else if(fileTypeExport===strings.excelLabel){
      setExcelActive("active-export-type");
      setPDFActive("pdf-type");
    }
    else {
      setPDFActive("pdf-type");
      setExcelActive("excel-type");
    }
  },[fileTypeExport])
  
 
  // Mapping data in another array 
  let excelSheetData=[];
  if (attendanceData && attendanceData.body && attendanceData.body.length > 0) {
    attendanceData.body.forEach((item) => {
      const duration= item.SignIn!==strings.naLabel && item.SignOut!==strings.naLabel ?TimeDifferenceCalculator(moment(item.SignIn).format(strings.timeFormat),moment(item.SignOut).format(strings.timeFormat)):strings.naLabel
      const dataObject = {
        'Emp id': item.empId,
        'Name': item.name,
        'Check In': item.SignIn!==strings.naLabel ?moment(item.SignIn).format(strings.timeFormat) : strings.naLabel,
        'Check out':item.SignOut!==strings.naLabel ? moment(item.SignOut).format(strings.timeFormat) : strings.naLabel,
        'Duration': duration,
        'Status': item.Status
      };
      excelSheetData.push(dataObject);
    });
  }

  const fileType = strings.fileTypeString;
  const fileExtension = strings.xlsxFileExtension;

  /*Excel file creation 
  In parameter it will take the array of data and file name .
    -According to array variable it will generate the data.
    -filename is the name of file after download it will be show.
  */
  const exportExcel = async (excelData,fileName) => {
    try {
      const ws = XLSX.utils.json_to_sheet(excelData);
      const wb = { Sheets: { data: ws }, SheetNames: [strings.dataLabel] };
      const excelBuffer = XLSX.write(wb, { bookType: strings.xlsxLabel, type: strings.arrayLabel });
      const data = new Blob([excelBuffer], { type: fileType });
      props.onHide();
      FileSaver.saveAs(data, fileName + fileExtension);
      toast.success(strings.reportExportedLabel , {toastId : strings.error6Label})
    } catch (error) {
      toast.error(strings.somethingWentWrongLabel , {toastId : strings.error7Label});
    }
  };

  return (
    <>
      <Modal
        {...props}
        size="md"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="export-report-pop-up-company"
      >
        <div className="main-container-report-attendance">
          <div className="main-container-company-export-report">
            <div className="name-export">{strings.exportLabel}</div>
            <div className="company-icon-export">
              <img
                src={closeIcon}
                alt="close-icon"
                onClick={() => {
                  props.onHide();
                }}
              />
            </div>
          </div>
          <div className="info-about-report">
            <div className="date-of-export">
              {strings.dateLabel}: {props.selectedDate}
            </div>
          </div>
          <div className="document-type-export-report">
            <div className={pdfActive} onClick={(()=>{
                  setFileTypeExport(strings.pdfLabel)
                })}>
              <img src={pdfIcon} alt="pdf-icon" className="pdf-icon-file"  />
            </div>

            <div className={excelActive}  onClick={(()=>{
                  setFileTypeExport(strings.excelLabel)
                })}>
             <img className="excel-icon-file" src={excelIcon} alt="excel-icon" />
            </div>
          </div>
          <div className="export-btn-pop-up">
          <button onClick={() => {
          fileTypeExport===strings.pdfLabel ? nav(constants.navigationLink.companyLevelPdfExport) :exportExcel(excelSheetData,companyName+"_"+props.selectedDate+"_"+strings.attendanceReportLabel)}} disabled={fileTypeExport==="" || !props.attendanceDataFetch || props.reportGeneration===true}>{props.reportGeneration ?  <SpinnerButtonMedium/>: strings.exportLabel}</button>
          </div>
        </div>
      </Modal>
    </>
  );
}

ExportCompanyAttendanceReport.propTypes = {
  onHide: PropTypes.func.isRequired,
  selectedDate: PropTypes.string.isRequired,
  attendanceDataFetch: PropTypes.any.isRequired,
  reportGeneration: PropTypes.any.isRequired
};

